<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<select-field label="Contact Type" :value.sync="contact.contact_type">
					<option value>--- Choose One ---</option>
					<option value="Submitted By">Submitted By</option>
					<option value="Person to Recieve Correspondence">Person to Recieve Correspondence</option>
					<option value="Involved Insured's Health Care Provider">Involved Insured's Health Care Provider</option>
				</select-field>
			</div>
			<div class="col-sm-12 col-md-6">
				<text-field label="Name / Title" :value.sync="contact.name"/>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<select-field
					label="Preferred Method of Receiving Communcations"
					:value.sync="contact.preferred_communications"
				>
					<option value>--- Choose One ---</option>
					<option value="Email">Email</option>
					<option value="Email">Phone</option>
					<option value="US Mail">US Mail</option>
				</select-field>
			</div>
			<div class="col-sm-12 col-md-6">
				<text-field type="email" label="Email" :value.sync="contact.email"/>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<text-field label="Phone Number" placeholder="Example: XXXXXXXXXX" :value.sync="contact.phone"/>
			</div>
			<div class="col-sm-12 col-md-6">
				<text-field label="Address" :value.sync="contact.address"/>
			</div>
		</div>
		<button type="button" class="btn btn-danger mb-3" @click="remove( index )">Remove Contact</button>
	</div>
</template>

<script>
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';

export default {
	name: 'ContactInformation',
	components: {
		TextField,
		SelectField,
	},
	props: ['contact', 'index', 'remove'],
};
</script>
